import {
  FavoriteSchema,
  IFavoriteProduct,
  IPagination,
} from '@shared/types.ts';
import { fetcher } from '@shared/fetcher';

export async function fetchAllFavoriteProducts(
  url: string
): Promise<IPagination<IFavoriteProduct> | undefined> {
  const res = await fetcher
    .get<IPagination<IFavoriteProduct>>(url)
    .catch(() => null);
  if (!res?.data) return undefined;

  return {
    data: res.data.data.filter((item) => FavoriteSchema.isValidSync(item)),
    meta: res.data.meta,
  };
}

export async function addFavoriteProduct(
  url: string,
  { arg }: { arg: { productId: number } }
) {
  return fetcher.post<{ message: string }>(url, {
    product_id: arg.productId,
  });
}

export async function removeFavoriteProduct(
  url: string,
  { arg }: { arg: { productId: number } }
) {
  return fetcher.delete(`${url}/${arg.productId}`);
}

export async function addAllFavoriteProducts(
  url: string,
  { arg }: { arg: { product_ids: number[] } }
) {
  return fetcher.post<{ message: string }>(url, arg);
}
